import { TableHeadersConfig } from "../../utils/utils";

export const customerTableConfig: TableHeadersConfig[] = [
  {
    title: '#',
  },
  {
    title: 'Full Name',
    sortingKey: 'firstName',
  },
  {
    title: 'Email',
    sortingKey: 'email',
  },
  {
    title: 'Telephone',
  },
  {
    title: 'Date of Birth',
  },
  {
    title: 'Gender',
  },
  {
    title: 'Address',
    sortingKey: 'address',
  },
  {
    title: 'City',
    sortingKey: 'city',
  },
  {
    title: 'Province',
    sortingKey: 'province',
  },
  {
    title: 'Postal code',
  },
  {
    title: 'Country',
  },
  {
    title: 'Action'
  },
];



// WEBPACK FOOTER //
// ./src/pages/customers/customersTableConfig.ts